import { useAppSelector } from "../../hooks/StoreHooks";
import { ActionModule } from "../../types/actionModule/actionModule";
import { ActionModuleInstanceResponse } from "../../types/actionModule/instance/actionModuleInstance";

export const useActionsData = () =>
  useAppSelector((state) => state.actions.actionsData);

export const useActionModuleIdNamePairs = () =>
  useAppSelector((state) =>
    state.actions.actionsData.map(({ id, name }) => ({ id, name }))
  );

export const useEditedActionData = () =>
  useAppSelector((state) => state.actions.actionToEdit);

export const useSpecificAction = (id: number): ActionModule | undefined =>
  useAppSelector((state) =>
    state.actions.actionsData.find((action) => action.id === id)
  );

export const useActionToEditData = ():
  | ActionModule
  | Partial<ActionModule>
  | null => useAppSelector((state) => state.actions.actionToEdit);

export const useActionModuleInstances = (): ActionModuleInstanceResponse[] =>
  useAppSelector((state) => state.actions.instances);
